export default __webpack_public_path__ + "static/media/Linero6.1903a552.png";